import { palette } from "../colors";

/**
 * Semantic color roles — purpose-based aliases over primitive palette values.
 * No raw hex/rgba literals; all values resolve through `palette`.
 */
export const color = {
  text: {
    primary: palette.text.primary,
    secondary: palette.text.secondary,
    disabled: palette.text.disabled,
    hint: palette.text.hint,
  },
  surface: {
    default: palette.background.default,
    elevated: palette.background.paper,
    subdued: palette.background.subdued,
  },
  border: {
    default: palette.border.default,
    strong: palette.border.strong,
    subtle: palette.border.subtle,
    focus: palette.border.focus,
    error: palette.border.error,
    divider: palette.divider,
  },
  feedback: palette.semantic,
  status: palette.status,
  banner: palette.banner,
  icon: palette.icon,
  overlay: palette.overlay,
  state: palette.state,
  alpha: palette.alpha,
} as const;

export type TColorSemantic = typeof color;
